import type { paths } from '@luxuryescapes/contract-svc-lux-loyalty'
import { mapLoyaltyActionRewards } from 'api/mappers/loyalty/mapLoyaltyActionRewards'
import requestUtils from 'api/requestUtils'

type GetCustomerActionRewardsResponse =
  paths['/api/lux-loyalty/customer/{customerId}/action-reward-records']['get']['responses']['200']['content']['application/json']

async function requestLoyaltyCustomerActionRewards(
  customerId: string,
): Promise<Array<App.LoyaltyActionReward>> {
  const response = await requestUtils.get<GetCustomerActionRewardsResponse>(
    `/api/lux-loyalty/customer/${customerId}/action-reward-records`,
    { credentials: 'include' },
  )

  return mapLoyaltyActionRewards(response.result)
}

export default requestLoyaltyCustomerActionRewards
